// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralFillActive, neutralFillStealthHover, neutralForegroundRest, neutralLayerCard, neutralOutlineActive } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { enums } from "../../../../utils/enums";

export const ProfileReportMenuSuperAppStyles = (config: DesignSystem) => ({
    profileReportMenuSuperAppContainer: {
        "border-radius": "12px 12px 0 0",
        width: "540px",
        "max-width": "100vw",

        "& .spacer": {
            "padding-top": "30px"
        },

        "& .cwt-report-list": {
            width: "540px",
            "max-width": "100vw",
            "max-height": "540px",
            "padding-top": "0",
            "padding-bottom": "70px",

            /* Hide Scrollbars */
            "-ms-overflow-style": "none",
            "&::-webkit-scrollbar ": {
                display: "none"
            },
            "&:-moz-any(#content,#appcontent) browser": {
                [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "-14px !important",
                "overflow-y": "scroll",
                "margin-bottom": "-14px !important",
                "overflow-x": "scroll"
            },

            "& .cwt-link": {
                "font-size": "16px"
            },

            "& .cwt-menu-header": {
                padding: "20px 27px",
                "border-bottom": "1px solid",
                "border-color": neutralOutlineActive,
                background: neutralLayerCard,
                "margin-bottom": "24px",
                position: "sticky",
                top: "0",

                "& .cwt-icon-label": {
                    "font-size": "22px",
                    color: neutralForegroundRest,
                    padding: "0"
                }
            },

            "& li": {
                color: neutralForegroundRest,
                background: neutralLayerCard,
                padding: "14px 24px",

                "&:hover": {
                    background: neutralFillStealthHover
                },

                "& .cwt-icon": {
                    color: neutralForegroundRest
                }
            },
            "& .cwt-access-li": {
                "font-size": "16px",
                "line-height": "20px"
            }
        },
        "& .cwt-report-list-final": {
            background: neutralFillActive,
            "padding-bottom": "70px"
        }
    },

    profileReportMenuSuperAppPopover: {
        bottom: "5px"
    }
});